// Utility for handling Sentry in both client and server environments
// This file provides a safe way to use Sentry functions that work in both SSR and client-side

let sentryModule: any = null

// Initialize Sentry module only on client-side
if (typeof window !== "undefined") {
	import("@sentry/react").then((module) => {
		sentryModule = module
	})
}

// Safe wrapper functions that work in both environments
export const captureMessage = (message: string) => {
	if (sentryModule?.captureMessage) {
		sentryModule.captureMessage(message)
	}
}

export const captureException = (error: Error) => {
	if (sentryModule?.captureException) {
		sentryModule.captureException(error)
	}
}

export const captureEvent = (event: any) => {
	if (sentryModule?.captureEvent) {
		sentryModule.captureEvent(event)
	}
}

// For cases where you need the full Sentry object
export const getSentry = () => {
	return sentryModule
}
